










import Vue from 'vue';
import SideMenuBase from '@/components/util/SideMenuBase.vue';

export default Vue.extend({
  name: 'SideMenu',
  components: {
    SideMenuBase,
  },
  // props: {
  //   user_code: String,
  // },
  data() {
    return {
      sampleList: [
        {itemID: 1, name: 'ご契約者情報', groupingID: 0, path: '/subscriberInfo'},
        {itemID: 2, name: 'ライセンス・お支払情報', groupingID: 0, path: '/license'},
        {itemID: 3, name: 'クライアントツール', groupingID: 0, path: '/clientTools'},
        {itemID: 4, name: 'お知らせ', groupingID: 0, path: '/news'},
        {itemID: 5, name: 'ガイド・よくある質問', groupingID: 0, path: '/help'},
        {itemID: 6, name: 'お問い合わせ', groupingID: 0, path: '/contact'},
        {itemID: 7, name: '利用規約', groupingID: 0, path: '/terms'},
        {itemID: 8, name: 'ログアウト', groupingID: 0, path: '/logout'},
      ],
      setSideMenu: '' as string,
    };
  },
  methods: {
    clickItem(i: any) {
      if (i.path === '/logout') {
        this.$emit('openLogoutModal');
      } else if (i.path === '/terms') {
        window.open('/service/terms-of-use/');
      } else {
        const path = i.path;
        this.$emit('pushPath', path);
        this.$router.push(path, () => {});
      }
    },
  },
  computed: {
    selectSampleList(): number {
      const path = this.$route.path;
      // return (this.sampleList as any[]).filter((c) => c.path === path)[0].itemID;
      const selected = this.sampleList.find((c) => c.path === path);
      if (selected) {
        return selected.itemID;
      } else {
        if (path.indexOf('help') > -1) {
          return 5; // help
        } else {
          return 0; // メニューが見つからない(ここには来ないはず)
        }
      }
    },
  },
  mounted() {
    this.setSideMenu = `c${this.selectSampleList}`;
  },
});
